import React, {Fragment} from "react";
import unescapeHtmlTag from "../../../../../core/utils/tools";
import {colorTargetReplacement} from "../../../../../core/utils/replace";
import {useSelector} from "react-redux";
import {COLOR_TARGETS} from "../../../../../core/constants/color";
import {renderPartStep, renderPersonalStep} from "./renderStepHelpers";
import ColorOption from "../molecules/ColorOption";
import PartOptionMain from "../molecules/PartOptionMain";
import ColorwayPreview from "../molecules/ColorwayPreview";
import ExteriorTonePreview from "../molecules/ExteriorTonePreview";
import useMainColors from "../../../../hooks/controller/useMainColors";

const MainStepsView = ({
                         stepObject,
                         navigationDataObject,
                         slideToSubHandler,
                         hasParentNav
                       }) => {
  const langData = useSelector(state => state.theme.langData);
  const {exteriorColors, interiorColors} = useMainColors(stepObject);


  const renderColorStep = (stepObject) => {
    return (
      <>
        {interiorColors && (
          <>
            {stepObject.stepItems.map((colorItemObject) => {
              if (colorItemObject.colorTarget === COLOR_TARGETS.INTERIOR_KEY ||
                colorItemObject.colorTarget === COLOR_TARGETS.INTERIOR_SECONDARY ||
                colorItemObject.colorTarget === COLOR_TARGETS.INTERIOR_THIRD
              ) {
                return null;
              }

              let code = colorTargetReplacement(colorItemObject.colorTarget);
              return (

                  <ColorOption
                    key={colorItemObject.id}
                    code={code}
                    colorItemObject={colorItemObject}
                    navigationDataObject={navigationDataObject}
                    stepObject={stepObject}
                    slideToSubHandler={slideToSubHandler}
                  />

              );
            })}
            <ColorwayPreview
              keyColorItem={interiorColors.keyColor}
              secondaryColorItem={interiorColors.secondaryColor}
              thirdColorItem={interiorColors.thirdColor}
              stepObject={interiorColors.stepObject}
              navigationDataObject={navigationDataObject}
              slideToSubHandler={slideToSubHandler}
            />
          </>
        )}

        {exteriorColors && (
          <>
            {stepObject.stepItems.map((colorItemObject) => {
              if (colorItemObject.colorTarget === COLOR_TARGETS.EXTERIOR_PRIMARY ||
                colorItemObject.colorTarget === COLOR_TARGETS.EXTERIOR_SECONDARY) {
                return null;
              }

              let code = colorTargetReplacement(colorItemObject.colorTarget);
              return (
                <ColorOption
                  key={colorItemObject.id}
                  code={code}
                  colorItemObject={colorItemObject}
                  navigationDataObject={navigationDataObject}
                  stepObject={stepObject}
                  slideToSubHandler={slideToSubHandler}
                />
              );
            })}

            <ExteriorTonePreview
              primaryColorItem={exteriorColors.primaryColor}
              secondaryColorItem={exteriorColors.secondaryColor}
              stepObject={exteriorColors.stepObject}
              navigationDataObject={navigationDataObject}
              slideToSubHandler={slideToSubHandler}
            />
          </>
        )}


        {!interiorColors && !exteriorColors &&
          stepObject.stepItems.map((colorItemObject, colorItemObjectIdx) => {
            let code = colorTargetReplacement(colorItemObject.colorTarget);
            return (
              <Fragment key={'ColorStep_' + colorItemObjectIdx}>
                <ColorOption
                  code={code}
                  colorItemObject={colorItemObject}
                  navigationDataObject={navigationDataObject}
                  stepObject={stepObject}
                  slideToSubHandler={slideToSubHandler}
                />
              </Fragment>
            );
          })
        }
      </>
    );
  };

  const renderHeader = () => {
    if (!hasParentNav) {
      return <h1>{unescapeHtmlTag(stepObject[langData.langName])}</h1>;
    }
    return null;
  };

  return (
    <div className={`option-h2 ${hasParentNav ? "spacing-adjust" : ""}`}>
      {renderHeader()}

      {stepObject.stepType === "COLOR" && renderColorStep(stepObject)}
      {(stepObject.stepType === "PART_3D" || stepObject.stepType === "MATERIAL") &&
        renderPartStep({
          PartComponent: PartOptionMain,
          stepObject,
          langData,
          navigationDataObject,
          slideToSubHandler
        })
      }
      {stepObject.stepType === "PART_2D" &&
        renderPersonalStep({
          PartComponent: PartOptionMain,
          stepObject,
          langData,
          navigationDataObject,
          slideToSubHandler
        })
      }
    </div>
  );
}

export default MainStepsView;
